// ============================================================================
// Section 6 — Safe, secure & permissioned (icon circle + title left, paragraph right)
// ============================================================================

import { Lock } from "lucide-react";

export default function SecuritySection() {
  return (
    <section id="security" className="border-t border-border/60 bg-muted/30 py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 md:items-center md:gap-16">
          {/* Left: circular icon badge + title */}
          <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:gap-8">
            <div
              className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-black text-white sm:h-20 sm:w-20"
              aria-hidden
            >
              <Lock className="h-8 w-8 sm:h-9 sm:w-9" strokeWidth={2} />
            </div>
            <h2 className="text-3xl font-bold leading-tight tracking-tight text-foreground sm:text-4xl">
              Safe, secure & permissioned
            </h2>
          </div>

          {/* Right: muted paragraph */}
          <p className="text-muted-foreground sm:text-lg">
            Stravo is built around property-based access. Owners control who gets invited, what they can do, and which
            properties they can see — keeping operations secure and simple.
          </p>
        </div>
      </div>
    </section>
  );
}
